import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { postDefaultLayout } from 'api/layout.service';

export const DEFAULT_LAYOUT_UPDATE_STORE_NAME = 'defaultLayoutUpdate';

export const updateDefaultLayout = createAsyncThunk(
  `${DEFAULT_LAYOUT_UPDATE_STORE_NAME}/update`,
  async (payload: { projectId: string, layoutId: string }) => {
    const { projectId, layoutId } = payload;
    await postDefaultLayout(projectId, layoutId);
  },
);

export interface DefaultLayoutUpdateState {
  processing: boolean
  error: any
}

export const initialDefaultLayoutUpdateState: DefaultLayoutUpdateState = {
  processing: false,
  error: null,
};

export const defaultLayoutUpdateSlice = createSlice({
  name: DEFAULT_LAYOUT_UPDATE_STORE_NAME,
  initialState: initialDefaultLayoutUpdateState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateDefaultLayout.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(updateDefaultLayout.fulfilled, (state) => {
      state.processing = false;
    });
    builder.addCase(updateDefaultLayout.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
  },
});

export const defaultLayoutUpdateActions = {
  ...defaultLayoutUpdateSlice.actions,
  updateDefaultLayout,
};

export default defaultLayoutUpdateSlice.reducer;
